import axios from "axios";
import { refreshAccessToken } from "../../services/authServices/auth.services";
import "firebase/compat/auth";

// Initialize axios instance with base URL
const API_URL = `${process.env.REACT_APP_BACKEND_WEB_API_LINK}`;
const axiosApi = axios.create({
  baseURL: API_URL,
});

axiosApi.interceptors.request.use(
  async (config) => {
    const token_obj = JSON.parse(localStorage.getItem(process.env.REACT_APP_DEV_USER_TOKEN));
    if (token_obj && token_obj.accessToken) {
      config.headers['Authorization'] = `Bearer ${token_obj.accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


// Axios response interceptor
axiosApi.interceptors.response.use(
  (response) => response,
  async (err) => {
    const { config, response } = err;
    if (!response) {
      // Handle network errors or other issues with no response
      console.error("No response received", err);
      return Promise.reject(err);
    }

    const { status } = response;

    if ((status === 403 || status === 401) && !config._retry) {
      config._retry = true;
      console.log("Token Expired..err: ", err);
      try {
        const newToken = await refreshAccessToken(); // Function to refresh token
        if (newToken) {
          const { idToken } = newToken;
          localStorage.setItem(
            process.env.REACT_APP_DEV_USER_TOKEN,
            JSON.stringify({ accessToken: idToken })
          );
          axiosApi.defaults.headers.common["Authorization"] = `Bearer ${idToken}`;
          config.headers["Authorization"] = `Bearer ${idToken}`;
          return axiosApi(config); // Retry original request with new token
        }
      } catch (tokenRefreshError) {
        return Promise.reject(tokenRefreshError);
      }
    } 
    // For other errors, simply reject the promise
    return Promise.reject(err);
  }
);

// Define HTTP request methods
export async function get(url, config = {}) {
  return await axiosApi.get(url, config);
}

export async function post(url, data, config = {}) {
  return await axiosApi.post(url, data, config);
}

export async function put(url, data, config = {}) {
  return await axiosApi.put(url, data, config);
}

export async function del(url, config = {}) {
  return await axiosApi.delete(url, config);
}

export async function patch(url, data, config = {}) {
  return await axiosApi.patch(url, data, config);
}
